<div class="grid-manage-columns-menu">
    <div class="row">
        <div class="checkbox grid-show-all-columns-option col-3">
            <input id="grid-show-all-columns" type="checkbox" name="grid-show-all-columns" class="grid-show-all-columns"/>
            <label for="grid-show-all-columns">{{locale "allColumns"}}</label>
        </div>
    </div>
    <div class="columns-checkboxes-container">
        {{#each rows}}
            <div class="row">
                <div class="col-1"></div>
                {{#each this}}
                    <div class="col-2">
                        <div class="checkbox">
                            <input id="grid-show-column-{{ cid }}" value="{{ cid }}" class="grid-show-column" type="checkbox" {{#if isChecked}}checked{{/if}}>
                            <label for="grid-show-column-{{ cid }}">{{#if label}}{{label}}{{else}}{{title}}{{/if}}</label>
                        </div>
                    </div>
                {{/each}}
                <div class="col-1"></div>
            </div>
        {{/each}}
    </div>

    <div class="row">
        <div class="col-1"></div>
        <div class="col-11 grid-manage-columns-buttons">
            <button type="button" class="btn btn-secondary js-update-columns">{{locale "update"}}</button>
            <button type="button" class="btn btn-tertiary js-cancel">{{locale "cancel"}}</button>
        </div>
    </div>
</div>

<div class="grid-manage-columns-backdrop"></div>
